import { useEffect } from "react";

function Socket({ socket, mandantId, shop, onMessage }) {
	useEffect(() => {
		console.log("add socket listener");
		socket.on("connect", onConnectEvent);
		socket.on("disconnect", onDisconnect);
		socket.on("subscribed", onSubrscribed);
		socket.on("events", onSocketEvents);

		onConnect();

		return () => {
			console.log("remove socket listener");
			socket.off("connect", onConnectEvent);
			socket.off("disconnect", onDisconnect);
			socket.off("subscribed", onSubrscribed);
			socket.off("events", onSocketEvents);
		};
	}, [shop]);

	// evento "connect" reale (anche riconnessioni): oltre a sottoscriversi, avvisa l'app
	function onConnectEvent() {
		onConnect();
		onMessage("socket_connected", null);
	}

	function onConnect() {
		console.log("Socket connected", socket.id);
		const hostname = window.location.hostname;
		let suffix = "";
		if (hostname.includes("localhost")) suffix = "_localhost";
		if (hostname.includes(".demo.")) suffix = "_demo";

		socket.emit("subscribe", "m" + mandantId + suffix + ".drivers.#");
		socket.emit("subscribe", "m" + mandantId + suffix + ".shops.#");
		socket.emit(
			"subscribe",
			"m" + mandantId + suffix + "." + (shop ? "s" + shop.id : "*") + ".orders.#"
		);
	}

	function onDisconnect() {
		console.log("Socket disconnected");
	}

	function onSubrscribed(data) {
		console.log(data);
	}

	function onSocketEvents(message) {
		console.log("new socket event: ", message);
		onMessage(message.table, message.data);
	}

	return null;
}

export default Socket;
